module.exports = __webpack_public_path__ + "img/button-light.16a298cc.png";